<template>
  <multiselect-item
    id="empresaPropia"
    track-by="id_empresas_propias"
    :value="value"
    @input="($event) => $emit('input', $event)"
    :custom-label="
      (option) => `${option.id_empresas_propias} - ${option.RazonSocial}`
    "
    placeholder="Seleccione empresa propia"
    :options="empresasPropiasOptions"
    :loading="isLoading"
    :disabled="disabled"
  >
  </multiselect-item>
</template>

<script>
import { get } from "lodash-es";
import AdaptarVueModel from "./AdaptarVueModel";
import axios from "axios";

export default {
  name: "SelectorEmpresaPropia",
  props: ["value", "clienteId", "disabled"],
  mixins: [AdaptarVueModel],
  mounted() {
    this.getData();
  },
  data: () => ({
    empresasPropiasOptions: [],
    isLoading: true,
  }),
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        let execute = {};
        if (this.clienteId) {
          execute = {
            method: "CLI.GetEmpresasPropiasWithCantidadDeContratosByClienteId",
            parameters: [
              { name: "id_cliente", value: this.$route.params.id_cliente },
            ],
          };
        } else {
          execute = {
            method: "CLI.GetEmpresasPropiasListaSimple",
            parameters: [],
          };
        }

        const resp = await axios.post("/execute", execute);

        if (resp.data.ok) {
          this.empresasPropiasOptions = get(resp, "data.result[0]", []);
          this.adaptarVueModel(
            this.empresasPropiasOptions,
            "id_empresas_propias",
            true,
          );
        } else {
          this.$msgBoxOk(resp.data.message);
        }
        this.isLoading = false;
        setTimeout(() => {
          this.$emit("ready", true);
        }, 0);
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
  },
};
</script>
